import React from 'react';
import classNames from 'classnames/bind';
import { number, oneOf, bool } from 'prop-types';
import segmentStatus from 'propTypes/segmentStatus';
import formatFloat from 'helpers/formatFloat';

import styles from './number-display.scss';

const cx = classNames.bind(styles);

export default function NumberDisplay({ value, status, unit, isHovered }) {
  return (
    <div
      className={cx(styles.main, {
        [styles[`status-${status}`]]: isHovered,
      })}
    >
      <span className={styles.value}>
        {formatFloat(value)}
      </span>
      {unit &&
        <span className={styles.unit}>
          {unit}
        </span>}
    </div>
  );
}

NumberDisplay.propTypes = {
  value: number.isRequired,
  status: segmentStatus.isRequired,
  isHovered: bool,
  unit: oneOf(['mph', 'kmh']),
};



// WEBPACK FOOTER //
// ./src/components/NumberDisplay/index.js